__turbopack_context__.v({
  "container": "styles-module-scss-module__xXE7ma__container",
  "promoContent": "styles-module-scss-module__xXE7ma__promoContent",
});
